import { render, staticRenderFns } from "./ZeroxaNFTModule.vue?vue&type=template&id=9a24d110&"
import script from "./ZeroxaNFTModule.vue?vue&type=script&lang=js&"
export * from "./ZeroxaNFTModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports